/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: PresenzeClienti.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Modules/PresenzeClienti.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 20/03/24, 11:28;
 * Updated at: 20/03/24, 11:28;
 *
 *
 */

import { ToastrService } from "ngx-toastr";
import { ApiPathsService } from "src/app/api-paths.service";
import { CampoAggiuntivo } from "src/app/shared/models/campo-aggiuntivo";


function Config() {
    var e = {

        type: 'P',
            addButton: true,
                managerLoggato: { },
        hideif: { hasNotCapacity: [] },
        restRoute: '/anagrafica/clienti/presenza',
            Label: '',
                Headers: [
                    //{nome: "N.", oggetti: ["id"]},
                    { nome: "Stato", oggetti: ['stato'], inputType: 'text' },
                    { nome: "Data", oggetti: ['data_inizio_prevista'], inputType: 'datetime-local' },
                ],
                    Azioni: [{
                        nome: 'Elimina',
                        close: true,
                        class: ' btn ',
                        labelClass: 'ml-1 text-danger font-weight-bold',
                        type: 'POST',
                        restRoute: '/anagrafica/clienti/presenza/delete',
                        preAlert: 'Sei sicuro di voler eliminare questo elemento?',
                        icon: 'fas fa-trash text-danger',
                        hideif: { func: (x) => { return x.id && !x.data_chiusura } },
                        placeholder: 'Elimina',
                        successMex: 'Elemento eliminato con successo',
                        parameter: [{ nome: "id", parameter: 'id' }]
                    },
                        // {
                        //   nome: 'Diario',
                        //   close: true,
                        //   icon: 'fas fa-plus text-info',
                        //   class: ' btn ',
                        //   labelClass: 'text-info font-weight-bold',
                        //   type: 'addTask',
                        //   taskType: 'E',
                        //   taskFilter: 'DI',
                        //   hideif: { fieldnotexist: 'id' }
                        // },
                    ],

                        campi: [
                            {
                                nome: 'Data e Ora',
                                oggetti: ['data_attivita'],
                                modificabile: true,
                                inputType: 'datetime-local',
                                disabledif: { fieldexist: 'data_chiusura' },
                                class: "col-lg-6",
                                required: true
                            },
                            {
                                nome: 'Ospite',
                                required: true,
                                source: '/anagrafica/clienti/list',
                                parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 }, {
                                    nome: "ruolo",
                                    value: 'C'
                                }, { nome: "inseriti", value: true }],
                                oggetti: ['cliente'],
                                internalOutput: 'clienteObject',
                                responseHasData: true,
                                OutputField: 'cliente',
                                OnChange: 'clienteObjectchange',
                                modificabile: true,
                                inputType: 'singleDropdown',
                                disabledif: { fieldexist: 'data_chiusura' },
                                placeholder: 'Seleziona un Ospite',
                                settings: {
                                    singleSelection: true,
                                    closeDropDownOnSelection: true,
                                    singleOutput: true,
                                    idField: 'id',
                                    textField: 'fullName',
                                    searchPlaceholderText: "Cerca",
                                    allowSearchFilter: true,
                                    allowRemoteDataSearch: false,
                                },
                                class: 'col-lg-6',
                                visibleifProhibited: true
                            },
                            {
                                nome: 'Stato',
                                required: true,
                                source: [{ id: 'P', label: 'Presente' }, { id: 'A', label: 'Assente' }],
                                oggetti: ['stato'],
                                internalOutput: 'statoObject',
                                OutputField: 'stato',
                                OnChange: 'statochange',
                                disabledif: { fieldexist: 'data_chiusura' },
                                modificabile: true,
                                inputType: 'singleDropdown',
                                placeholder: 'Seleziona uno Stato',
                                settings: {
                                    singleSelection: true,
                                    closeDropDownOnSelection: true,
                                    singleOutput: true,
                                    idField: 'id',
                                    textField: 'label',
                                    searchPlaceholderText: "Cerca",
                                    allowSearchFilter: true,
                                    allowRemoteDataSearch: false,
                                },
                                class: 'col-lg-6',
                                visibleifProhibited: true
                            },
                            {
                                nome: 'Note',
                                oggetti: ['note'],
                                modificabile: true,
                                inputType: 'textarea',
                                class: "col-lg-6",
                                disabledif: { fieldexist: 'data_chiusura' },
                                requiredif: {
                                    fieldEqual: [{ source: 'stato', value: 'AL' }]
                                },
                            },
                            {
                                nome: 'Accessi',
                                oggetti: ['figli'],
                                modificabile: true,
                                type: 'table',
                                header: [

                                    { nome: "Entrata", oggetti: ['data_inizio_prevista'], modificabile: true, inputType: 'datetime-local', class: 'col-lg-12' },
                                    { nome: "Uscita", oggetti: ['data_fine_prevista'], modificabile: true, inputType: 'datetime-local', class: 'col-lg-12' },
                                    CampoAggiuntivo.SingleDropdown("Persona Entrata", 'personaIngresso', '/anagrafica/persone/list', 'fullName', {
                                        parameter: [{ nome: 'page', value: 1 }, { nome: 'size', value: 200 }],
                                        responseHasData: true,
                                        class: 'col-lg-12',
                                        url: '/anagrafica/persone/list'
                                    }),
                                    CampoAggiuntivo.SingleDropdown("Persona Uscita", 'personaUscita', '/anagrafica/persone/list', 'fullName', {
                                        parameter: [{ nome: 'page', value: 1 }, { nome: 'size', value: 200 }],
                                        responseHasData: true,
                                        class: 'col-lg-12',
                                            url: '/anagrafica/persone/list'
                                    }),
                                    // { nome: "Note", oggetti: ['note'], modificabile: true, inputType: 'text', class: 'col-lg-12' },

                                ],
                                AzioniTask: [
                                    {
                                        nome: '',
                                        close: false,
                                        icon: 'fas fa-plus text-info',
                                        class: ' btn ',
                                        labelClass: 'text-info font-weight-bold',
                                        type: 'func',
                                        hideif: {
                                            func: (x) => {
                                                return true;
                                            }
                                        },
                                        func: (task, api, endFunc) => {
                                            task.figli = task?.figli ?? [];
                                            let id = Math.floor(Math.random() * 101);
                                            while (task.figli.findIndex(x => x.id == id) > -1) {
                                                id = Math.floor(Math.random() * 101);
                                            }
                                            let data = task.data_attivita.substring(0, 11) + new Date().toLocaleString().substring(12, 17);
                                            task.figli.push({ id: id, data_inizio_prevista: data, data_fine_prevista: '', note: '' })
                                        },
                                        validate: (item: any, Toastr: ToastrService, api: ApiPathsService) => {
                                            return true
                                        },
                                    },
                                ],
                                azioni: [
                                    {
                                        type: 'func',
                                        func: (task, api, endFunc) => {
                                            let index = task.figli.findIndex(x => x.id == task.id);
                                            task.figli.splice(index, 1);
                                        },
                                        icon: 'fa-trash',
                                        tooltip: 'Elimina',
                                        color: 'red'
                                    }
                                ],
                                class: 'col-lg-12'
                            },


                        ]

    };
    return e;
}

export var PresenzeClienti = () => {
    var env = {
        Menu: [
            {
                path: "/listautenti/presenze",
                title: "Registro presenze",
                icon: "fas fa-book",
                capacita: ['gestione-clienti']
            },
            {
                path: "/task/clientitask/P",
                title: "Inserimento presenze",
                icon: "fas fa-calendar",
                capacita: []
            },
        ],
        ClientiAddOn: {
            Tabs: [
                {
                    tipo: 'presenze',
                    titolo: 'Presenze',
                    filtri: []
                },
            ]
        },
        filtrife: [
            { id: "P", label: "Presenze", capacita: [], module: undefined, tipo: 'P' },
        ],
        TaskAddon: {
            DynamicFields: [Config()]
        }
    };
    return env;
}
